import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IPatientWaitingListGroomesResponse } from "@/api_framework/api_modals/Patients";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setPWLGroomers } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const usePatientWaitingGroomersListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    // dispatch(
    //   setLoading({
    //     key: "",
    //     status: true,
    //   })
    // );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(PATIENT_WAITING_LIST?.GROOMERS_LIST?.baseURL ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IPatientWaitingListGroomesResponse>) => {
          if (res.data.status === true) {
            dispatch(
              setPWLGroomers({
                data: res.data.data,
              }),
            );
          } else {
            dispatch(
              setPWLGroomers({
                data: [],
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching user role.");
          }
          if (e.status === 400) {
            toast.error(e.message);
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
